"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
/**
 * Button with border that can be selected
 * @constructor
 */
function SelectableButton(_a) {
    var { selected, onAnimationEnd } = _a, props = __rest(_a, ["selected", "onAnimationEnd"]);
    const ref = react_1.default.useRef(null);
    /**
     * Animation duration in milliseconds
     */
    const ANIMATION_DURATION = 200;
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { nodeRef: ref, in: true, appear: true, timeout: ANIMATION_DURATION, classNames: "mount-animation", "data-e2e": 'SelectableButton_CSSTransition', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { nodeRef: ref, in: selected, timeout: {
                appear: 0,
                enter: ANIMATION_DURATION,
                exit: ANIMATION_DURATION,
            }, appear: true, onEntered: isAppearing => {
                if (onAnimationEnd) {
                    onAnimationEnd(isAppearing);
                }
            }, "data-e2e": 'SelectableButton_CSSTransition', children: (0, jsx_runtime_1.jsx)(Button, Object.assign({ ref: ref, animationDuration: ANIMATION_DURATION, selected: selected }, props, { "data-e2e": 'SelectableButton_Button' })) }) }));
}
exports.SelectableButton = SelectableButton;
const Button = styled_components_1.default.button `
  width: 100%;
  padding: 12px;
  margin: 0;
  box-sizing: border-box;

  background: ${({ theme }) => theme.designSystem.highlightedBackground};
  border-radius: 4px;
  border: none;
  color: ${({ theme }) => theme.designSystem.white};
  font-size: 16px;
  line-height: 1.5;
  text-transform: uppercase;

  cursor: pointer;

  &.mount-animation-appear {
    opacity: 0;
  }

  &.mount-animation-appear-active {
    opacity: 1;
    transition: opacity ${({ animationDuration }) => animationDuration}ms
      ease-in;
  }

  &.mount-animation-appear-done {
    opacity: 1;
  }

  &.enter {
    background: ${({ theme }) => theme.designSystem.highlightedBackground};
    color: ${({ theme }) => theme.designSystem.white};
  }

  &.enter-active {
    background: ${({ theme }) => theme.designSystem.white};
    color: ${({ theme }) => theme.designSystem.background};

    ${({ animationDuration }) => (0, styled_components_1.css) `
      transition: background ${animationDuration}ms ease-in,
        color ${animationDuration}ms ease-in;
    `};
  }

  &.enter-done {
    background: ${({ theme }) => theme.designSystem.white};
    color: ${({ theme }) => theme.designSystem.background};
  }

  &.exit {
    background: ${({ theme }) => theme.designSystem.white};
    color: ${({ theme }) => theme.designSystem.background};
  }

  &.exit-active {
    background: ${({ theme }) => theme.designSystem.highlightedBackground};
    color: ${({ theme }) => theme.designSystem.white};

    ${({ animationDuration }) => (0, styled_components_1.css) `
      transition: background ${animationDuration}ms ease-in,
        color ${animationDuration}ms ease-in;
    `};
  }
`;
